<template>
    <div class="row">
        <div class="col-12 col-lg-12" v-if="$slots.items">
            <div class="list-item-carousel owl-carousel owl-theme owl-single-item" ref="carouselContainer">
                <slot-component v-for="(item, index) in $slots.items" :key="index" :vnode="item" />
            </div>
        </div>

<!--        <div :class="columnWidths" v-else v-for="item in $slots.items">-->
<!--            <slot-component :vnode="item"/>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
    components: {
        SlotComponent: {
            functional: true,
            render: (createElement, context) => context.data.attrs.vnode
        }
    },

    props: {
        itemsPerPage: {
            type: Number,
            default: 4
        }
    },

    computed:
    {
        columnWidths()
        {
            const itemsPerPage = Math.min(Math.max(this.itemsPerPage, 1), 4);

            return [
                "col-12",
                itemsPerPage === 1 ? "col-sm-12" : "col-sm-6",
                "col-md-" + (12 / itemsPerPage)
            ];
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initializeCarousel();
        });
    },

    updated()
    {
        this.initializeCarousel();
    },

    methods:
    {
        initializeCarousel()
        {
            if (this.$slots.items && this.$slots.items[0].tag)
            {
                const $owl = $(this.$refs.carouselContainer);

                // do not render, if no html element is inside of the carousels container
                if (!$owl.children().length)
                {
                    return;
                }

                $owl.owlCarousel({
                    onInitialized(){
                        $owl.find(".owl-carousel.owl-loaded").each(function() {
                            $(this).trigger("refresh.owl.carousel");
                        });
                    },
                    autoHeight: true,
                    items: this.itemsPerPage,
                    slideBy: this.itemsPerPage,
                    responsive: {
                        0: {
                            stagePadding: App.templateType === "item" && this.$slots.items.length > 1 ? 30 : 0, // Or any number you would like
                            items: 1,
                            slideBy: 1,
                            loop: App.templateType === "item" && this.$slots.items.length > 1,
                            dots: this.$slots.items.length > 1,
                        },
                        576: {
                          items: this.itemsPerPage > 1 ? 2 : 1,
                          slideBy: this.itemsPerPage > 1 ? 2 : 1,
                            stagePadding: App.templateType === "item" && this.$slots.items.length > 1 ? 40 : 0, // Or any number you would like
                            loop: App.templateType === "item" && this.$slots.items.length > 1,
                            dots: this.$slots.items.length > 2,
                        },
                        768: {
                            items: this.itemsPerPage > 3 ? 3 : this.itemsPerPage,
                            slideBy: this.itemsPerPage > 3 ? 3 : this.itemsPerPage,
                            dots: this.$slots.items.length > (this.itemsPerPage > 3 ? 3 : this.itemsPerPage),

                        },
                        992: {
                            items: this.itemsPerPage,
                            slideBy: this.itemsPerPage,
                            dots: this.$slots.items.length > this.itemsPerPage,
                        }
                    },
                    lazyLoad: false,
                    loop: false,
                    margin: 2,
                    mouseDrag: true,
                    nav: true,
                    navClass: [
                        "owl-single-item-nav left carousel-control list-control-special",
                        "owl-single-item-nav right carousel-control list-control-special"
                    ],
                    navContainerClass: "",
                    navText: [
                        "<svg class=\"carousel__arrow--prev\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg>",
                        "<svg class=\"carousel__arrow--next\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg>"
                    ],
                    smartSpeed: 100
                });
            }
        }
    }
}
</script>
